import AppStore from 'app/icons/Custom/AppBadges/AppStore';
import Clickable from 'atoms/Clickable/Clickable';
import React from 'react';

const AppStoreBadge = (): JSX.Element => (
  <Clickable
    display='flex'
    href='https://itunes.apple.com/us/app/mighty-networks/id1081683081?mt=8'
  >
    <AppStore />
  </Clickable>
);

export default AppStoreBadge;
